module.exports = "pegasus_template/assets/themelp1/travel/106.png";